import React, { useEffect, useState } from "react";
import { View, Image, Text, FlatList, TouchableOpacity } from "react-native";
import { MaterialIcons } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/core";
import { formatGPXBalance } from "../../utils/formatNumber";
import styles from "./style";
import api from "../../services/api";
import AsyncStorage from "@react-native-async-storage/async-storage";

const TokenReleases = ({ loading }) => {
    const navigation = useNavigation();

    const [actives, setActives] = useState([]);

    useEffect(() => {
        async function loadActives() {
            const token = await AsyncStorage.getItem("JWT_TOKEN");
            loading(true)
            api.get("/actives", {
                headers: { Authorization: `Basic ${token}` },
            }).then(response => {
                loading(false)
                setActives(response.data[0]);
            }).catch(error => {
                loading(false)
                console.log(error)
            })
        }
        loadActives();
    }, []);

    return actives.map((item, i) => (
        <TouchableOpacity
            key={i}
            onPress={() =>
                navigation.navigate({
                    name: "Token",
                    params: { ...item, name: item.name_token },
                })
            }
            style={styles.contentItem}
        >
            <Image
                source={{
                    uri: `https://filesgpx.s3.us-east-2.amazonaws.com/${item.path}`,
                }}
                style={styles.img}
            />
            <View style={styles.textsItem}>
                <Text style={styles.titleCoin}>{item.name_token}</Text>
                <View style={styles.infoPrice}>
                    <Text style={styles.infosCoin}>Valor: </Text>
                    <Text style={styles.priceCoin}>
                        {formatGPXBalance(item.single_value)} GPX
                    </Text>
                </View>
                {/* <Text style={styles.infosCoin}>1 GPX = 0,34520BRL (02/04)</Text> */}
            </View>
            {/* <Text style={styles.currencyPercentage}>0,67%</Text> */}
            <MaterialIcons
                padding={20}
                name="keyboard-arrow-right"
                size={30}
                color="#2C2C2E"
                style={styles.iconGo}
                onPress={() => { }}
            />
        </TouchableOpacity>
    ));
};

export default TokenReleases;
